import React from "react";
import NavBar from "../components/NavBar";
import { useNavigate } from "react-router-dom";
import pokemon from "../assets/pokemon.png"
import gPoster from "../assets/g-poster.png"
const Projet = () => {
    const navigate = useNavigate()
  return (
    <>
      <NavBar />
      <section class="py-5">
        <div class="container px-5 mb-5">
          <div class="text-center mb-5">
            <h1 class="display-5 fw-bolder mb-0">
              <span class="text-gradient d-inline">Projets personnels</span>
            </h1>
          </div>
          <div class="row gx-5 justify-content-center">
            <div class="col-lg-11 col-xl-9 col-xxl-8">
              <div class="card overflow-hidden shadow rounded-4 border-0 mb-5">
                <div class="card-body p-0">
                  <div class="d-flex align-items-center cardToFormate">
                    <div class="p-5">
                      <h2 class="fw-bolder">Gestion de personnage animé</h2>
                      <p>
                        Vous avez la possibilité de parcourir la liste complète
                        des personnages de Naruto dans l'onglet 'Naruto'. Pour
                        l'onglet 'Pokémon', en vous connectant à l'interface
                        avec le nom d'utilisateur 'raj' et le mot de passe
                        'raj', vous pouvez effectuer des modifications, des
                        ajouts et des suppressions de personnages{" "} <br />
                        <a href="https://naruto-pokemon-app.web.app/login" target="_blank">visité</a>
                      </p>
                    </div>
                    <img
                      class="img-fluid"
                      src={pokemon}
                      style={{width:'300px'}}
                      alt="..."
                    />
                    </div>
                </div>
              </div>
              <div class="card overflow-hidden shadow rounded-4 border-0">
                <div class="card-body p-0">
                  <div class="d-flex align-items-center cardToFormate">
                    <div class="p-5">
                      <h2 class="fw-bolder">G-poster-Movie</h2>
                      <p>
                        Une application web permettant d'effectuer des
                        recherches sur les films de votre choix, en utilisant
                        une API gratuite pour trouver des vidéos et obtenir des
                        informations détaillées sur chaque film ou dessin animé <br />
                        <a href="https://g-poster-movie.web.app/" target="_blank  ">visité</a>
                      </p>
                    </div>
                    <img
                      class="img-fluid"
                      style={{width:"300px"}}
                      src={gPoster}
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="py-5 bg-gradient-primary-to-secondary text-white">
        <div class="container px-5 my-5">
          <div class="text-center">
            <h2 class="display-4 fw-bolder mb-4">
              Mettons en place un projet ensemble
            </h2>
            <a
              class="btn btn-outline-light btn-lg px-5 py-3 fs-6 fw-bolder"
              onClick={(ev)=>{
                ev.preventDefault()
                navigate('/Contacte')
              }}
            >
              Contactez-moi
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Projet;
